import ReferencePayment from "../features/referencePayment/ReferencePayment";
import { hajjPaymentService } from "../features/referencePayment/referencePaymentServices";

const Hajj = () => <ReferencePayment service={hajjPaymentService} />;

export default Hajj;
